<template>
    <v-sheet>
        <v-row class=" pa-1" :dense="true">
            <v-col cols="7">
                <v-row :dense="true">
                    <v-col class="section-heading font-weight-bold">
                        Parent Assembly
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col>
                        <v-row :dense="true">
                            <v-col class="d-flex justify-end align-center" cols="3">
                                Parent:
                            </v-col>

                            <v-col cols="2">
                                <v-text-field
                                    v-model="form.parent.AssemblySeq"
                                    type="number"
                                    placeholder="0"
                                    variant="outlined"
                                    density="compact"
                                    color="primary"
                                    :readonly="true"
                                    hide-details
                                ></v-text-field>
                            </v-col>

                            <v-col cols="7">
                                <v-text-field v-model="form.parent.PartNum" variant="outlined" density="compact" color="primary" :readonly="true" hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col>
                        <v-row :dense="true">
                            <v-col cols="3">
                                <v-btn class="w-100" color="close" @click="openParentAssemblyDescriptionDialog">Description</v-btn>
                            </v-col>

                            <v-col cols="9">
                                <v-text-field v-model="form.parent.Description" variant="outlined" density="compact" color="primary" :readonly="true" hide-details></v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-row :dense="true">
                    <v-col cols="3" class="d-flex align-center justify-end">
                        <v-btn class="w-100" color="close" :disabled="true">
                            Operation
                        </v-btn>
                    </v-col>

                    <v-col cols="2">
                        <v-text-field
                            v-model="form.part.RelatedOprSeq"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            type="number"
                            placeholder="0"
                            hide-details
                            :readonly="true"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="7">
                        <v-text-field
                            v-model="form.part.RelatedOpDesc"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            hide-details
                            :readonly="true"
                        ></v-text-field>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>

        <v-divider class="my-3" />

        <v-row :dense="true">
            <v-col class="section-heading font-weight-bold">
                Part Information
            </v-col>
        </v-row>

        <v-row :dense="true">
            <v-col cols="2">
                <v-btn class="w-100" color="close" @click="openPartDialog" :disabled="job?.JobClosed !== '0'">Part...</v-btn>
            </v-col>

            <v-col cols="6">
                <v-text-field
                    ref="partNumInput"
                    v-model="form.part.PartNum"
                    variant="outlined"
                    density="compact"
                    color="primary"
                    :readonly="parseInt(job?.JobClosed) !== 0"
                    hide-details
                    @focusout="jobAsmblPartNumChange"
                    @keydown.enter="jobAsmblPartNumEnter"
                    @keydown.tab="jobAsmblPartNumChange"
                ></v-text-field>

            </v-col>
        </v-row>

        <v-row :dense="true">
            <v-col cols="2">
                <v-btn class="w-100" color="close" @click="openPartAssemblyDescriptionDialog">Description...</v-btn>
            </v-col>

            <v-col cols="6">
                <v-text-field
                    v-model="form.part.Description"
                    variant="outlined"
                    density="compact"
                    color="primary"
                    :readonly="parseInt(job?.JobClosed) !== 0"
                    hide-details
                    @focusout="jobAsmblPartDescriptionChange"
                    @keydown.enter="jobAsmblPartDescriptionChange"
                    @keydown.tab="jobAsmblPartDescriptionChange"
                ></v-text-field>
            </v-col>
        </v-row>

        <v-divider class="my-3" />

        <v-row class="bg-red-lighten-3 pa-1" :dense="true">
            <v-col>
                <div class="section-heading font-weight-bold">
                    Quantities
                </div>

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Qty/Parent:
                    </v-col>

                    <v-col cols="3">
                        <v-text-field
                            type="number"
                            placeholder="0.00000000"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            :readonly="parseInt(job?.JobClosed) !== 0"
                            hide-details
                            v-model="form.part.QtyPer"
                            step="0.0001"
                            @focusout="QtyPerChange"
                            @keydown.enter="QtyPerChange"
                            @keydown.tab="QtyPerChange"
                        ></v-text-field>
                    </v-col>
                </v-row>

                <!-- <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Pull Qty:
                    </v-col>

                    <v-col cols="3">
                        <v-text-field
                            type="number"
                            placeholder="0.00000000"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            :readonly="parseInt(job?.JobClosed) !== 0"
                            hide-details
                            v-model="form.part.PullQty"
                            @focusout="PullQtyChange"
                            @keydown.enter="PullQtyChange"
                            @keydown.tab="PullQtyChange"
                        ></v-text-field>
                    </v-col>
                </v-row> -->

                <!-- <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Overrun Qty:
                    </v-col>

                    <v-col cols="3">
                        <v-text-field
                            type="number"
                            placeholder="0.00"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            :readonly="parseInt(job?.JobClosed) !== 0"
                            hide-details
                            v-model="form.part.OverRunQty"
                            @focusout="OverRunQtyChange"
                            @keydown.enter="OverRunQtyChange"
                            @keydown.tab="OverRunQtyChange"
                        ></v-text-field>
                    </v-col>
                </v-row> -->

                <v-row :dense="true">
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Required Qty:
                    </v-col>

                    <v-col cols="3">
                        <v-text-field
                            type="number"
                            placeholder="0.00"
                            variant="outlined"
                            density="compact"
                            color="primary"
                            :readonly="true"
                            hide-details
                            v-model="form.part.RequiredQty"
                        ></v-text-field>
                    </v-col>
                </v-row>


                <v-row>
                    <v-col class="d-flex align-center justify-end" cols="2">
                        Pull as assembly:
                    </v-col>

                    <v-col cols="3">
                        <v-checkbox
                            @update:modelValue="handleMtrPullFromStockChange"
                            v-model="form.part.PullAsAsmParent"
                            :disabled="!form.part.PullAsAsmParent && form.part.PullAsAsm"
                            :model-value="form.part.PullAsAsmParent || form.part.PullAsAsm"
                            label="Pull From Existing Stock"
                            color="purple darken-2"
                            theme="light"
                        ></v-checkbox>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-sheet>

    <v-dialog v-model="dialogs.assemblyParentDescriptionDialog">
        <v-card>
            <v-card-text class="p-3 overflow-y-auto">
                <v-textarea v-model="form.parent.Description" :readonly="true" variant="outlined"></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogs.assemblyParentDescriptionDialog = false"
                    >Cancel
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogs.assemblyPartDescriptionDialog">
        <v-card>
            <v-card-text class="p-3 overflow-y-auto">
                <v-textarea v-model="form.part.Description" :readonly="true" variant="outlined"></v-textarea>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialogs.assemblyPartDescriptionDialog = false"
                    >Cancel
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialogs.partSearchDialog">
        <PartSearch @partNumberReceived="partNumberReceived" />
    </v-dialog>
</template>

<script>
    import { useJobEntryStore } from "../../../../../../stores/ProjectManagement/JobEntry";
    import { mapWritableState } from "pinia";
    import PartSearch from "../../../../Part/PartSearch.vue";
    import axios from "axios";

    export default {
        name: "AssemblyWindow",
        computed: {
            ...mapWritableState(useJobEntryStore, [
                "job",
                "relatedOperationByOpr",
                "currentAssembly",
                "currentAssemblyParent",
                "setErrorMessage",
                "setTemporaryMessage",
                "currentAssemblyOperations",
                "refreshAssemblies",
                "overlay"
            ]),
            parentRelatedOperation() {
                return this.relatedOperationByOpr(this.currentAssemblyParent?.AssemblySeq, this.currentAssemblyParent?.RelatedOperation);
            }
        },
        watch: {
            currentAssembly(value, oldValue) {
                this.parseData();
            }
        },
        components: {
            PartSearch,
        },
        mounted() {
            this.fetchWarehouses();
            this.parseData();
        },
        data() {
            return {
                form: {
                    parent: {
                        AssemblySeq: null,
                        PartNum: null,
                        RevisionNum: null,
                        Description: null,
                        RelatedOprSeq: null,
                        RelatedOpDesc: null
                    },
                    part: {
                        AssemblySeq: null,
                        PartNum: null,
                        RevisionNum: null,
                        Description: null,
                        IUM: null,
                        QtyPer: null,
                        PullQty: null,
                        OverRunQty: null,
                        RequiredQty: null,
                        Warehouse: null,
                        RelatedOprSeq: null,
                        RelatedOpDesc: null,
                        PullAsAsmParent: true
                    }
                },
                dialogs: {
                    partSearchDialog: false,
                    assemblyParentDescriptionDialog: false,
                    assemblyPartDescriptionDialog: false
                },
                runningProcesses: {
                    updatingPartNum: false,
                    updatingPartDescription: false,
                    updatingQtyPer: false,
                    updatingPullPer: false,
                    updatingOverRunQty: false,
                    updatingRequiredQty: false,
                    updatingWarehouseCode: false,
                    PullAsAsmParent: false
                },
                warehouseArray: []
            }
        },
        methods: {
            openPartDialog() {
                // this.dialogs.partSearchDialog = true;
            },
            openParentAssemblyDescriptionDialog() {
                this.dialogs.assemblyParentDescriptionDialog = true;
            },
            openPartAssemblyDescriptionDialog() {
                this.dialogs.assemblyPartDescriptionDialog = true;
            },
            parseData() {
                this.form = {
                    parent: {
                        AssemblySeq: this.currentAssemblyParent?.AssemblySeq,
                        PartNum: this.currentAssemblyParent?.PartNum,
                        RevisionNum: this.currentAssemblyParent?.RevisionNum,
                        Description: this.currentAssemblyParent?.Description,
                        RelatedOprSeq: this.currentAssemblyParent?.RelatedOperation,
                        RelatedOpDesc: this.currentAssemblyParent?.RelatedOperationDesc,
                    },
                    part: {
                        AssemblySeq: this.currentAssembly?.AssemblySeq,
                        PartNum: this.currentAssembly?.PartNum,
                        RevisionNum: this.currentAssembly?.RevisionNum,
                        Description: this.currentAssembly?.Description,
                        IUM: this.currentAssembly?.IUM,
                        QtyPer: parseFloat(this.currentAssembly?.QtyPer).toFixed(3),
                        PullQty: parseFloat(this.currentAssembly?.PullQty).toFixed(),
                        OverRunQty: parseFloat(this.currentAssembly?.OverRunQty).toFixed(),
                        RequiredQty: parseFloat(this.currentAssembly?.RequiredQty).toFixed(),
                        WarehouseCode: this.currentAssembly?.WarehouseCode,
                        RelatedOprSeq: this.currentAssembly?.RelatedOperation,
                        RelatedOpDesc: this.currentAssembly?.RelatedOperationDesc,
                        PullAsAsmParent: Boolean(this.currentAssembly?.PullAsAsmParent),
                        PullAsAsm: Boolean(this.currentAssembly?.PullAsAsm),
                    }
                }

            },
            async handleMtrPullFromStockChange(value){
                if (!this.runningProcesses.PullAsAsmParent && (this.form.part.PullAsAsmParent !== value)) {
                    this.runningProcesses.PullAsAsmParent = true;

                    let params = {
                        type: 'PullAsAsmParent',
                        PullAsAsmParent: (value),
                    }
                    await this.sendUpdateCall(params);

                    this.runningProcesses.PullAsAsmParent = false;
                }
            },
            partNumberReceived(partNum) {
                this.form.part.PartNum = partNum;
                this.jobAsmblPartNumChange();
                this.dialogs.partSearchDialog = false;
            },
            jobAsmblPartNumEnter() {
                this.$refs.partNumInput.blur();
            },
            async jobAsmblPartNumChange() {
                if (!this.runningProcesses.updatingPartNum && (this.form.part.PartNum !== this.currentAssembly.PartNum)) {

                    this.runningProcesses.updatingPartNum = true;

                    let params = {
                        type: 'AsmblPartNum'
                    }

                    await this.sendUpdateCall(params);

                    this.runningProcesses.updatingPartNum = false;
                }
            },
            async jobAsmblPartDescriptionChange() {
                if (!this.runningProcesses.updatingPartDescription && (this.form.part.Description !== this.currentAssembly.Description)) {
                    this.runningProcesses.updatingPartDescription = true;

                    let params = {
                        type: 'AsmblPartDescription',
                        Description: this.form.part.Description
                    }

                    await this.sendUpdateCall(params);

                    this.runningProcesses.updatingPartDescription = false;
                }
            },
            async QtyPerChange() {
                if (!this.runningProcesses.updatingQtyPer && (this.form.part.QtyPer !== this.currentAssembly.QtyPer)) {
                    this.runningProcesses.updatingQtyPer = true;

                    let params = {
                        type: 'AsmblQtyPer',
                        QtyPer: this.form.part.QtyPer
                    }

                    await this.sendUpdateCall(params);

                    this.runningProcesses.updatingQtyPer = false;
                }
            },
            // async PullQtyChange() {
            //     if (!this.runningProcesses.updatingPullQty && (this.form.part.PullQty !== this.currentAssembly.PullQty)) {
            //         this.runningProcesses.updatingPullQty = true;

            //         let params = {
            //             type: 'AsmblPullQty',
            //             PullQty: this.form.part.PullQty
            //         }

            //         await this.sendUpdateCall(params);

            //         this.runningProcesses.updatingPullQty = false;
            //     }
            // },
            async OverRunQtyChange() {
                if (!this.runningProcesses.updatingOverRunQty && (this.form.part.OverRunQty !== this.currentAssembly.OverRunQty)) {
                    this.runningProcesses.updatingOverRunQty = true;

                    let params = {
                        type: 'AsmblOverRunQty',
                        OverRunQty: this.form.part.OverRunQty
                    }

                    await this.sendUpdateCall(params);

                    this.runningProcesses.updatingOverRunQty = false;
                }
            },
            async WarehouseCodeChange() {
                if (!this.runningProcesses.updatingWarehouseCode && (this.form.part.WarehouseCode !== this.currentAssembly.WarehouseCode)) {
                    this.runningProcesses.updatingWarehouseCode = true;

                    let params = {
                        type: 'AsmblWarehouseCode',
                        WarehouseCode: this.form.part.WarehouseCode
                    }

                    await this.sendUpdateCall(params);

                    this.runningProcesses.updatingWarehouseCode = false;
                }
            },
            async sendUpdateCall(additionalParams) {
                if (this.currentAssembly && this.job.JobNum && parseInt(this.job.JobClosed) === 0) {
                    this.overlay = true;
                    let params = {
                        PartNum: this.form.part.PartNum,
                        AssemblyId: this.currentAssembly.id,
                        AssemblySeq: this.currentAssembly?.AssemblySeq,
                        ParentAssemblySeq: this.currentAssemblyParent?.AssemblySeq,
                        JobNum: this.job.JobNum,

                    }
                    params = {...params, ...additionalParams}

                    await axios.post(route('api.epicor.jobs.asmbl.update'), params)
                        .then((response) => {
                            if (response.data.Status === 0) {
                                this.setErrorMessage(response.data.Message)
                                this.refreshAssemblies('assembly');
                            } else if (response.data.Status === 1) {
                                this.refreshAssemblies('assembly');

                                if (response.data.Description) {
                                    this.form.part.Description = response.data.Description
                                }

                                this.setTemporaryMessage("Value has been updated and saved");
                            }
                        })
                        .catch((response) => {
                            console.log("Err: " + response)
                        })
                }
            },
            fetchWarehouses() {
                axios
                .get(
                    route("api.buildings.index", {
                        countryCodeFK: "US",
                        state: "NY",
                    })
                )
                .then((res) => {
                    this.warehouseArray = res.data;
                });
            }
        }
    }
</script>

<style scoped>

</style>
